<template>
  <div class="message-box" v-if="isShow">
    <div class="message-box-content">
      <h2>温馨提示</h2>
      <p v-html="message"></p>
      <div @click="handleClick">我知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '您已成功投递, <br> 请您保持联系方式畅通噢～',
    },
  },
  computed: {
    isShow: {
      get() {
        return this.show
      },
      set(bool) {
        this.$emit('update:show', bool)
      },
    },
  },
  methods: {
    handleClick() {
      this.isShow = false
    },
  },
}
</script>

<style lang="less" scoped>
.message-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;

  &-content {
    width: 376px;
    background: #fff;
    border-radius: 6px;
    text-align: center;

    h2 {
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    p {
      padding: 15px 0;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
    }

    div {
      margin: 20px;
      height: 40px;
      color: #fff;
      line-height: 40px;
      background: #cd3324;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
</style>
